import * as Yup from 'yup';

export const TransactionLimitSchema = Yup.object().shape({
  amount: Yup.number()
    .label('Number of transactions')
    .required()
    .min(1)
    .max(500000)
    .integer(),
  reference: Yup.string().label('Reference').required(),
  endDate: Yup.string().label('End date').required()
});
